<template>
  <div class="creatOrder" v-cloak>
    <div class="order-header flex align-cen">
      <div class="header-container-left" @click="openGo">
        <img
          src="../../../assets/images/HeroopSys.png"
          alt=""
          class="sider-logo"
        />
      </div>
      <div class="header-container-con"></div>
      <div class="header-container-right mft" style="margin-right: 24px">
        <el-dropdown>
          <span
            class="el-dropdown-link flex align-cen"
            style="color: #fff; cursor: pointer"
          >
            <img :src="user.avatar || require('../../../assets/images/head.png')" alt="" class="sider-logo">
           {{user.name}} 
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="openMan"><i class="icon-al-laptop"></i> 进入后台</el-dropdown-item>
            <el-dropdown-item @click.native="openSet"><i class="icon-al-cog"></i> 账号设置</el-dropdown-item>
            <!-- <el-dropdown-item  @click.native="openOrder"><i class="icon-al-file"></i> 订单管理</el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
            <!-- 左边轮播图 -->
        <div class="centerDiv">
            <div class="thumb-example flex">
                 <div class="preview-wrap">
                    <!-- 商品视频 -->
                    <div class="goods_video" v-if="flag && radio==0">
                        <div class="videocontainer">
                            <video :src="list.videoUrl"  type="video/*" controls style="width:100%;height:300px"></video>
                        </div>
                    </div>
                    <!-- 商品图片 -->
    <div class="goods_imgs" v-if="!flag && radio==1">
            <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
                   <div class="swiper-button-prev" slot="button-next"></div>
         <div class="swiper-button-next" slot="button-next"></div>
          <swiper-slide class="slide-1"
          v-for="(item,index) in swiperList"
          :style="{'background':'url(' + item.imgUrl + ') no-repeat 0 0','background-size':'100% 100%'}"
          >
          </swiper-slide>
         </swiper>
        <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
          <swiper-slide class="slide-1"
          v-for="(item,index) in swiperList"
         :style="{'background':'url(' + item.imgUrl + ') no-repeat 0 0','background-size':'100% 100%'}"
          >
          </swiper-slide>
        </swiper>
                    </div>
        <!-- 视频图片切换按钮 -->
        <div class="switchBtn" style="text-align:center;margin-top:20px" v-if="list.videoUrl">
             <el-radio-group v-model="radio" size="small" @change="tabSwich">
            <el-radio-button :label="0">视频</el-radio-button>
            <el-radio-button :label="1"  >照片</el-radio-button>
            </el-radio-group>
        </div>
     </div>
                         <!-- 右边订单详细信息 -->
        <div class="itemInfo-wrap mft">
          <div class="info flex align-cen">
            <div class="label">订购服务</div>
            <div class="info-con mft">{{ list.appName }}</div>
          </div>
          <div class="info flex align-cen">
            <div class="label">开通企业</div>
            <div class="info-con mft">
              <el-select v-model="value" placeholder="请选择"
              @change="dataSuccess"
              >
                <el-option
                  v-for="(item, index) in options"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="info flex align-cen">
            <div class="label">联系电话</div>
            <div class="info-con mft">{{phone}}</div>
          </div>
          <div class="info">
            <div class="label">选购方案</div>
            <div class="info-con">
              <div class="ace-tab-goods-card">
                <div class="sku-goods-wrap">
                  <div class="sku-goods-grid">
                    <div
                      class="
                        ace-row ace-row-wrap
                        sku-goods-row
                        goods-simple-row
                      "
                    >
                      <div
                        class="ace-col ace-col-6 sku-goods-col-simple"
                        v-for="(item, index) in list.appSkuList"
                        :key="index"
                      >
                        <div
                          class="goods-card-simple"
                          :class="{ current: active == index }"
                          @click="checkSku(item, index)"
                        >
                          <div class="simple-card-header">
                            <div class="simple-header-title">
                              {{ item.name }}
                            </div>
                          </div>
                          <div class="simple-content-form">
                            <div class="ace-form ace-medium">
                              <div class="form-item-list flex align-cen">
                                <div class="ace-form-item-label ace-left">
                                  账号个数
                                </div>
                                <div class="ace-form-item-label ace-right">
                                  {{ item.accountNum || "无限制" }}
                                </div>
                              </div>
                              <div class="form-item-list flex align-cen">
                                <div class="ace-form-item-label ace-left">
                                  使用期限(月)
                                </div>
                                <div class="ace-form-item-label ace-right">
                                  {{ item.deadline || "无限期" }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="simple-price-box">
                            <div class="right-price-box flex">
                              <div class="price-content price-content1 flex">
                                <div class="price-icon">¥</div>
                                <div class="price-trade">
                                  {{ item.originalPrice }}
                                </div>
                              </div>
                              <div class="price-content flex">
                                <div
                                  class="price-icon"
                                  style="margin-right: 5px"
                                >
                                  ¥
                                </div>
                                <div class="price-trade">
                                  {{ item.salePrice }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="info flex align-cen">
            <div class="info-con mft">
              <span style="margin-right:20px">订单金额</span> <span class="mft-price" style="color:#ea3a3a"> {{priceInfo.salePrice}}</span>
            </div>
          </div>
          <div class="info flex align-cen" style="justify-content:center">
                 <el-checkbox v-model="checked">
                        我已阅读并同意  
                        <span @click.stop="openAgreement">《和隆优化服务条款》</span>
            </el-checkbox>
             <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load btn" 
           @click="creatOrder"
            >
                提交
           </el-button>
            <!-- <div class="btn" >提交</div> -->
          </div>
        </div>
            </div>
        </div>
  </div>
</template>
<script>
import { dowloadDetail, enBusiness ,editOrder} from "@/api/enterprise/index"; // 详情、企业列表、创建订单、订单列表
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import LocaStorage from "../../../utils/localstorage.js";
export default {
  name: "creatOrder",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    let self = this
    return {
    propList:{},
    loading:false,
    phone:'',
    flag:true,
    radio:0,
    checked:true,
     priceInfo:{},
      current: "current",
      active: "",
      value: "",
      businessName:'',
      options: [],
      user: {},
      swiperList: [],
      list: {},
      swiperOptionTop: {
        loop: false,
        loopedSlides: 9, // looped slides should be the same
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOptionThumbs: {
        loop: false,
        loopedSlides: 9, // looped slides should be the same
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
    };
  },
watch: {
  $route: {
    handler: function(val, oldVal){
      console.log(val);
    },
    // 深度观察监听
    deep: true
  }
},
  created() {
      const token1 = LocaStorage.setAge().get("token1");
    const userinfo1 = LocaStorage.setAge().get("userinfo1");
        let decryptQuery=this.$base64.decode(this.$route.query.dataJson); // 解密
       this.propList = JSON.parse(decryptQuery)
       this.priceInfo = this.propList.data
      this.active = this.propList.index;
    this.getInfo();
    this.getEnBusinee();
    this.user = userinfo1;
    // this.priceInfo = this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
  },
  mounted() {
    this.$bus.$emit("isShow", false);
  },
  methods: {
        // 打开后台
        openMan(){
               // return this.$util.Notifi('加急开发中～','error','fa-exclamation-circle');
             enBusiness({},'enterprise')
            .then(res =>{
                if(res.code == 0){
                 if(res.data.length == 1){
                  localStorage.removeItem('businessInfo')
                 LocaStorage.setAge().set('businessInfo',res.data[0])
                const newurl = this.$router.resolve({path:'/webenterpriseManage/index', query: {}})
                 window.open(newurl.href,'_blank')
                }else{               
                 const newurl = this.$router.resolve({name:'enBusiness', query: {}})
                 window.open(newurl.href,'_blank')
                }
                }else{
                     this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                }
            })
        },
       // 打开设置
        openSet(){
            const newurl = this.$router.resolve({name:'enHLyhSetting', query: {}})
                 window.open(newurl.href,'_blank')
        },
    // 开通企业切换
    dataSuccess(e){
       let newarr = this.options.filter(item => item.id ==e)
        this.phone = newarr[0].phone
    },
    // 企业切换
    // dataSuccess(e){
    //    this.value = e.value
    //    this.businessName = e.label
    // },
     // 打开订单管理
        openOrder(){
          return  this.$util.Notifi('加急开发中，请您耐心等待新版本～','error','fa-exclamation-circle');
            this.$router.push({
                name:'orderAdmin',
                 query: {
                 id:this.propList.id,
                }
            })
        },
    // 切换
    tabSwich(){
        
      if(this.radio == 1) 
      {this.flag = false
       this.swiperOptionTop.loop = this.swiperList.length > 5 ? true : false;
           this.swiperOptionThumbs.loop = this.swiperList.length > 5 ? true : false;
            this.$nextTick(() => {
    const swiperTop = this.$refs.swiperTop.swiper;
    const swiperThumbs = this.$refs.swiperThumbs.swiper;
    swiperTop.controller.control = swiperThumbs;
    swiperThumbs.controller.control = swiperTop;
    });
      } else{
        this.flag = true
      }
    },
    // 创建订单
    creatOrder(){
        if(!this.value) return  this.$util.Notifi('请选择开通企业','error','fa-exclamation-circle');
        if(!this.checked) return  this.$util.Notifi('请先同意用户协议','error','fa-exclamation-circle');
        if(this.priceInfo.salePrice == 0) this.$util.Notifi('金额为0，暂时无法创建订单','error','fa-exclamation-circle');
         this.loading = true
         let params = {
            appId:this.priceInfo.appId,
            appSkuId:this.priceInfo.id,
            businessId:this.value,
            orderAmount:this.priceInfo.salePrice,
            officialType:2
         }
        editOrder(params,'post','enterprise')
        .then(res =>{
           this.loading = false
            if(res.code == 0){
               this.$util.Notifi('订单提交成功','success','fa-check'); 
                setTimeout(() => {
                     this.$router.push({
                name:'buyOrderHlyh',
                query:{
                    id:res.data
                }
            })
                 }, 100);
            }else{
                this.loading = false
                this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
            }
        })
        .catch(err =>{
            this.loading = false
            this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
        })
    },
    openAgreement(){
         const newurl = this.$router.resolve({name: 'Agreement', query: {type:'3'}})
                 window.open(newurl.href,'_blank')
    },
    // 选择规格
    checkSku(data, i) {
      this.active = i;
      this.priceInfo = data
    },
    // 返回上一层
    openGo() {
         this.$bus.$emit("isShow", true);
      this.$router.push({
        name: "endowloadHlyhDetail",
        query: {
          id: this.propList.id,
          type: "2",
        },
      });
    },
    getInfo() {
      dowloadDetail(
        {
          id: this.propList.id,
        },
        "enterprise"
      )
        .then((res) => {
          res.code == 0 ? (this.list = res.data) : (this.list = {});
          document.title = res.data.appName + '提交订单' || '提交订单'
          this.swiperList = res.data.appImagesList;   
             if(res.data.videoUrl){
                this.flag = true
                this.radio = 0
             }else{
                this.flag = false
                this.radio = 1
             }
                     if(!this.flag){
        this.swiperOptionTop.loop = res.data.appImagesList.length > 5 ? true : false;
        this.swiperOptionThumbs.loop = res.data.appImagesList.length > 5 ? true : false;
        this.$nextTick(() => {
    const swiperTop = this.$refs.swiperTop.swiper;
    const swiperThumbs = this.$refs.swiperThumbs.swiper;
    swiperTop.controller.control = swiperThumbs;
    swiperThumbs.controller.control = swiperTop;
    });
    }
        })
        .catch((err) => {});
    },
    getEnBusinee() {
      enBusiness({}, "enterprise")
        .then((res) => {
          this.options = res.data;
          this.value = res.data[0].id;
          this.businessName = res.data[0].name
          this.phone = res.data[0].phone
        })
        .catch((err) => {
             this.$router.push({
            name:'enHlyhLogin',
            query: {
              iscreat:true,
               replaceUrl:'creatOrderHlyh',
               dataJson : this.$route.query.dataJson
            }
         })
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.creatOrder {
  width: 100%;
  position: relative;
  .order-header {
    position: relative;
    background: #fff;
    height: 64px;
    position: relative;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
    .header-container-left {
      line-height: 64px;
      height: 64px;
      margin-left: 24px;
      margin-right: 24px;
      img {
        width: 80px;
      }
    }
    .header-container-right {
      img {
        width: 30px;
        margin-right: 10px;
         height: 30px;
        border-radius: 50%;
      }
      .right-btn {
        height: 64px;
        margin-left: 24px;
        margin-right: 24px;
        color: #333;
        .right-login {
          margin-right: 24px;
          cursor: pointer;
        }
        .trial {
          padding: 10px 24px;

          color: #333;
          border-radius: 5px;
          cursor: pointer;
        }
      }
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    height: 36px;
    top: 55%;
    width: 36px;
    cursor: pointer;
    transition: 0.3s;
    border-radius: 50%;
    background-color: rgba(31, 45, 61, 0.11);
    color: #fff;
    transform: translateY(-50%);
    text-align: center;
    font-size: 12px;
    z-index: 999;
  }
  .swiper-button-prev,
  .swiper-button-next:hover {
    background-color: rgba(31, 45, 61, 0.23);
  }
  .swiper-button-next {
    right: 10px;
  }
  .swiper-button-prev {
    left: 10px;
  }
  .swiper-button-prev:after,
  .swiper-button-next:after {
    font-size: 12px;
  }
  .centerDiv {
    max-width: 1210px;
    min-height: 560px;
    margin: 0 auto;
    .thumb-example {
      background-color: transparent;
      margin-top: 20px;
      .preview-wrap {
        width: 422px;
        position: relative;
      }
      .swiper-slide {
        background-repeat: no-repeat;
        background-position: top;
        background-size: cover;
        object-fit: cover;
      }
      // .slide-1 {
      //   background-image: url("../../../assets/images/banner.png");
      // }
      // .slide-2 {
      //   background-image: url("../../../assets/images/banner1.jpg");
      // }
      .gallery-top {
        width: 100%;
        .swiper-slide {
          min-height: 300px;
        }
      }
      .gallery-thumbs {
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 10px;
        justify-content: space-between;
      }
      .gallery-thumbs .swiper-slide {
        width: 80px;
        height: 50px;
        opacity: 0.4;
        margin-right: 5px !important;
      }
      .gallery-thumbs .swiper-slide-active {
        opacity: 1;
        border: 2px solid #e53e41;
        box-sizing: border-box;
      }
    }
    .itemInfo-wrap {
      width: calc(1210px - 452px);
      margin-left: 30px;
      box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
      padding: 20px;
      .info {
        padding-bottom: 10px;
        .btn{
            height: 32px;
    line-height: 30px;
    font-size: 14px;
    padding: 0 16px;
    border-radius: 2px;
    font-family: inherit;
    border-width: 1px;
    border-style: solid;
    text-align: center;
    vertical-align: middle;
    box-sizing: border-box;
    cursor: pointer;
    transition: all 0.3s;
    background: #409eff;
    color: #fff;
        }
        .label {
          color: #999;
          font-size: 12px;
        }
        .info-con {
          font: 700 16px Arial, "microsoft yahei";
          color: #666;
          margin-bottom: 5px;
          .ace-tab-goods-card {
            padding: 20px 0 50px;
            box-sizing: border-box;
            margin: 0 auto;
            width: 100%;
            padding-top: 0;
            .sku-goods-wrap {
              min-height: 220px;
              transition: all 0.3s;
              .goods-simple-row {
                padding: 5px 0;
                margin: 0 -10px;
                flex-wrap: wrap;
                display: flex;
                .sku-goods-col-simple {
                  padding: 5px 10px;
                  box-sizing: border-box;
                  flex: 0 0 33%;
                  width: 33%;
                  max-width: 33%;
                  .current {
                    border: 1px solid #e53e41 !important;
                  }
                  .goods-card-simple {
                    cursor: pointer;
                    background: #fff;
                    position: relative;
                    border: 1px solid #ededec;
                    transition: box-shadow 0.3s ease-out;
                    .simple-card-header {
                      padding: 0 20px 10px;
                      padding-top: 28px;
                      box-sizing: border-box;
                      background: rgb(235, 236, 236);
                      .simple-header-title {
                        position: relative;
                        text-align: left;
                        font-size: 18px;
                        color: #181818;
                        letter-spacing: 0.55px;
                        line-height: 30px;
                        margin-bottom: 8px;
                        font-weight: 600;
                        transition: all 0.3s;
                      }
                    }
                    .simple-content-form {
                      padding: 8px 20px;
                      box-sizing: border-box;
                      .ace-medium {
                        width: 100%;
                        .form-item-list {
                          box-sizing: border-box;
                          margin-bottom: 3px;
                          .ace-form-item-label {
                            font-size: 14px;
                            padding-right: 0;
                            display: inline-block;
                            vertical-align: top;
                            color: #999;
                          }
                          .ace-right {
                            padding-left: 40px;
                            color: #3d3d3d;
                          }
                        }
                      }
                    }
                    .simple-price-box {
                      padding: 0 20px;
                      box-sizing: border-box;
                      border-top: 1px solid #ebecec;
                      .simple-show-label {
                        margin-top: 12px;
                        margin-bottom: 12px;

                        .tag-item-text {
                          background: #155bd4;
                          border-radius: 2px;
                          text-align: left;
                          font-size: 12px;
                          color: #fff;
                          letter-spacing: 0.46px;
                          display: inline-block;
                          padding: 2px 12px;
                          line-height: 20px;
                          margin-right: 8px;
                        }
                      }
                      .right-price-box {
                        margin-bottom: 14px;
                        margin-top: 20px;
                        .price-content {
                          margin-bottom: 4px;
                          .price-icon {
                            color: #ea3a3a;
                            font-size: 16px;
                            letter-spacing: 0.81px;
                          }
                          .price-trade {
                            text-align: left;
                            color: #ea3a3a;
                            line-height: 15px;
                            font-size: 24px;
                            letter-spacing: 1.2px;
                          }
                        }
                        .price-content1 {
                          margin-right: 20px;
                          .price-icon,
                          .price-trade {
                            color: #999;
                            text-decoration: line-through;
                          }
                        }
                      }
                    }
                    .buy-button-box {
                      width: 100%;
                      height: 36px;
                      text-align: center;
                      line-height: 36px;
                      color: #fff;
                      background: #ea3a3a;
                      cursor: pointer;
                    }
                  }
                  .goods-card-simple:hover {
                    box-shadow: 0 0 15px 0 rgb(0 0 0 / 10%);
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
::v-deep {
  .el-dropdown-link {
    color: #333 !important;
  }
}
@media (max-width: 640px){
  .creatOrder{
    margin-top: -56px;
     overflow-x: hidden;
    .centerDiv{
      width: 100%;
      min-height: auto;
      .thumb-example{
        margin-top: 0;
        display: block;
        .itemInfo-wrap{
          width: auto;
          margin:20px;
          .goods-simple-row{
            display: block !important;
            .sku-goods-col-simple{
              width: 100% !important;
              max-width: 100% !important;
            }
          }
        }
      }
    }
  }
}
</style>